module.exports = __webpack_public_path__ + "img/b.898ef60c.jpg";